import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import addfolder from '@kso/ui/lib/images/icons/add-folder.png';
import filelink from '@kso/ui/lib/images/icons/filelink.png';
import logos from '@kso/ui/lib/images/icons/logo-s.png';
import logo from '@kso/ui/lib/images/icons/logo.png';
import addresslisticon from '@kso/ui/lib/images/icons/address-list-icon.png';
import apptodo from '@kso/ui/lib/images/icons/app-todo.png';
import meeting from '@kso/ui/lib/images/icons/meeting.png';
import wpscalendaricon from '@kso/ui/lib/images/icons/wps-calendaricon.png';
import wpsformicon from '@kso/ui/lib/images/icons/wps-form-icon.png';
import upload1 from '@kso/ui/lib/images/icons/upload1.png';
import uploadfile from '@kso/ui/lib/images/icons/upload-file.png';
import uploadfolder from '@kso/ui/lib/images/icons/upload-folder.png';
import mcompany from '@kso/ui/lib/images/icons/m-company.png';
import computer from '@kso/ui/lib/images/icons/computer.png';
import tel from '@kso/ui/lib/images/icons/tel.png';
import dialogteamfolders from '@kso/ui/lib/images/icons/dialog-team-folder-s.png';
import foldersselected from '@kso/ui/lib/images/icons/folder-s-selected.png';
import books from '@kso/ui/lib/images/icons/books.png';
import entspace from '@kso/ui/lib/images/icons/entspace.png';
import addcircle from '@kso/ui/lib/images/icons/add-circle.png';
import myTeams from '@kso/ui/lib/images/icons/myTeams.svg';
import memberprivilege from '@kso/ui/lib/images/icons/member-privilege.png';
import barcode from '@kso/ui/lib/images/icons/barcode.svg';
import industryactivationguide from '@kso/ui/lib/images/icons/industry-activation-guide.png';
import saveandedit from '@kso/ui/lib/images/icons/save-and-edit.png';
import outlink from '@kso/ui/lib/images/icons/out-link.svg';
import reminderwarning from '@kso/ui/lib/images/icons/reminder-surface-warning-l-24.svg';
import ctwarning from '@kso/ui/lib/images/icons/ct-warning.svg';
import ctsuccess from '@kso/ui/lib/images/icons/ct-success.svg';
import triangleWarn from '@kso/ui/lib/images/icons/triangleWarn.svg';
import cropTeam from '@kso/ui/lib/images/icons/crop-team.svg';
import savesuccess from '@kso/ui/lib/images/icons/save-success.png';
import savefail from '@kso/ui/lib/images/icons/save-fail.png';
import address from '@kso/ui/lib/images/icons_new/address.svg';
import addressLink from '@kso/ui/lib/images/icons_new/address-link.svg';
import calendar from '@kso/ui/lib/images/icons_new/calendar.svg';
import calendarLink from '@kso/ui/lib/images/icons_new/calendar-link.svg';
import contract from '@kso/ui/lib/images/icons_new/contract.svg';
import contractLink from '@kso/ui/lib/images/icons_new/contract-link.svg';
import folderLink from '@kso/ui/lib/images/icons_new/folder-link.svg';
import todo from '@kso/ui/lib/images/icons_new/todo.svg';
import todoLink from '@kso/ui/lib/images/icons_new/todo-link.svg';
import folderComputer from '@kso/ui/lib/images/icons_new/folder-computer.svg';
import folderCompany from '@kso/ui/lib/images/icons_new/folder-company.svg';
import folderUpload from '@kso/ui/lib/images/icons_new/folder-upload.svg';
import folderAdd from '@kso/ui/lib/images/icons_new/folder-add.svg';
import folderPhone from '@kso/ui/lib/images/icons_new/folder-phone.svg';
import fileUpload from '@kso/ui/lib/images/icons_new/file-upload.svg';
import upload from '@kso/ui/lib/images/icons_new/upload.svg';
import { PlugCtr } from '@ecis/plugctr';
import KFormatIcon from '@kso/ui/lib/FormatIcon';
import '@kso/ui/lib/FormatIcon/style.css';

// 新框架支持png类型：同cloud-Icon
var _docs = ['doc', 'form', 'kw', 'mp3', 'note', 'otl', 'motl', 'pdf', 'pof', 'pom', 'audio', 'ppt', 'txt', 'video', 'xls', 'ksheet', 'zip', 'img', 'h5', 'cad2d', 'cad3d', 'unknown', 'address-list-icon', 'app-todo', 'meeting', 'wps-calendaricon', 'wps-form-icon', 'books', 'logo', 'contract', 'ckt', 'entspace', 'dbt', 'ofd', 'resh', 's2t', 'epub'];
var _folder = ['folder', 'secret-folder', 'share-folder', 'trash-folder', 'upload1', 'upload-file', 'upload-folder', 'devices', 'm-company', 'computer', 'tel', 'add-folder', 'filelink', 'add-circle', 'barcode', 'sharefolder2', 'share-folder2'];
var _s = ['doc-s', 'form-s', 'img-s', 'kw-s', 'mp3-s', 'audio-s', 'otl-s', 'motl-s', 'pdf-s', 'pof-s', 'pom-s', 'note-s', 'ppt-s', 'txt-s', 'unknown-s', 'video-s', 'xls-s', 'ksheet-s', 'zip-s', 'h5-s', 'cad2d-s', 'cad3d-s', 'ckt-s', 'dbt-s', 'ofd-s', 'resh-s', 's2t-s', 'epub-s', 'dialog-team-folder-s', 'folder-s', 'secret-folder-s', 'folder-s-selected', 'logo-s', 'contract-s', 'memberprivilege', 'share-folder-s', 'devices-s', 'myTeam-s'];
var _l = ['doc-l', 'form-l', 'img-l', 'kw-l', 'audio-l', 'otl-l', 'motl-l', 'pdf-l', 'pof-l', 'pom-l', 'note-l', 'ppt-l', 'txt-l', 'unknown-l', 'video-l', 'xls-l', 'ksheet-l', 'zip-l', 'h5-l', 'cad2d-l', 'cad3d-l', 'ckt-l', 'dbt-l', 'ofd-l', 'resh-l', 's2t-l', 'epub-l', 'folder-l', 'secret-folder-l', 'received-folder-l', 'trash-folder-l', 'share-folder-l', 'sharefolder2-l', 'share-folder2-l', 'devices-l'];
var _xl = ['doc-xl', 'form-xl', 'img-xl', 'kw-xl', 'audio-xl', 'otl-xl', 'motl-xl', 'pdf-xl', 'pof-xl', 'pom-xl', 'note-xl', 'ppt-xl', 'txt-xl', 'unknown-xl', 'video-xl', 'xls-xl', 'ksheet-xl', 'zip-xl', 'h5-xl', 'cad2d-xl', 'cad3d-xl', 'ckt-xl', 'dbt-xl', 'ofd-xl', 'resh-xl', 's2t-xl', 'epub-xl', 'folder-xl', 'secret-folder-xl', 'received-folder-xl', 'trash-folder-xl', 'share-folder-xl', 'sharefolder2-xl', 'share-folder2-xl', 'devices-xl'];
var _others = ['industry-activation-guide', 'save-and-edit', 'outlink', 'reminderwarning', 'ctwarning', 'ctsuccess', 'triangleWarn', 'cropTeam', 'save-success', 'save-fail'];
// 快捷方式
var _link = ['dbtLink', 'docLink', 'imgLink', 'ksheetLink', 'otlLink', 'motlLink', 'pdfLink', 'pofLink', 'pomLink', 'pptLink', 'xlsLink', 'kwLink', 'cad2dLink', 'cad3dLink', 'audioLink', 'videoLink', 's2tLink'];
var _linkS = ['dbtLink-s', 'docLink-s', 'imgLink-s', 'ksheetLink-s', 'otlLink-s', 'motlLink-s', 'pdfLink-s', 'pofLink-s', 'pomLink-s', 'pptLink-s', 'xlsLink-s', 'kwLink-s', 'cad2dLink-s', 'cad3dLink-s', 'audioLink-s', 'videoLink-s', 's2tLink-s', 'epubLink-s'];
var _linkL = ['dbtLink-l', 'docLink-l', 'imgLink-l', 'ksheetLink-l', 'otlLink-l', 'motlLink-l', 'pdfLink-l', 'pofLink-l', 'pomLink-l', 'pptLink-l', 'xlsLink-l', 'kwLink-l', 'cad2dLink-l', 'cad3dLink-l', 'audioLink-l', 'videoLink-l', 's2tLink-l', 'epubLink-l'];
var _linkXl = ['dbtLink-xl', 'docLink-xl', 'imgLink-xl', 'ksheetLink-xl', 'otlLink-xl', 'motlLink-xl', 'pdfLink-xl', 'pofLink-xl', 'pomLink-xl', 'pptLink-xl', 'xlsLink-xl', 'kwLink-xl', 'cad2dLink-xl', 'cad3dLink-xl', 'audioLink-xl', 'videoLink-xl', 's2tLink-xl', 'epubLink-xl'];
var fileFormatIcon = ['doc', 'form', 'img', 'kw', 'audio', 'otl', 'motl', 'pdf', 'pof', 'pom', 'note', 'ppt', 'txt', 'unknown', 'video', 'xls', 'ksheet', 'zip', 'h5', 'cad2d', 'cad3d', 'ckt', 'dbt', 'ofd', 'resh', 'uof', 's2t', 'epub'];
var folderFormatIcon = ['devices', 'device', 'upload-folder', 'secret-folder', 'trash-folder', 'share-folder', 'sharefolder2', 'share-folder2', 'received-folder', 'folder'];
var imgIcons = {
  logos: logos,
  logo: logo,
  addresslisticon: addresslisticon,
  apptodo: apptodo,
  meeting: meeting,
  wpscalendaricon: wpscalendaricon,
  wpsformicon: wpsformicon,
  upload1: upload1,
  uploadfile: uploadfile,
  uploadfolder: uploadfolder,
  mcompany: mcompany,
  computer: computer,
  tel: tel,
  dialogteamfolders: dialogteamfolders,
  books: books,
  foldersselected: foldersselected,
  entspace: entspace,
  addfolder: addfolder,
  filelink: filelink,
  addcircle: addcircle,
  myTeams: myTeams,
  memberprivilege: memberprivilege,
  barcode: barcode,
  industryactivationguide: industryactivationguide,
  saveandedit: saveandedit,
  outlink: outlink,
  reminderwarning: reminderwarning,
  ctwarning: ctwarning,
  ctsuccess: ctsuccess,
  triangleWarn: triangleWarn,
  cropTeam: cropTeam,
  savesuccess: savesuccess,
  savefail: savefail
};

var newImgIcons = {
  addresslisticon: address,
  addresslisticonLink: addressLink,
  wpscalendaricon: calendar,
  wpscalendariconLink: calendarLink,
  contract: contract,
  contractLink: contractLink,
  folderLink: folderLink,
  apptodo: todo,
  apptodoLink: todoLink,
  computer: folderComputer,
  mcompany: folderCompany,
  uploadfolder: folderUpload,
  addfolder: folderAdd,
  tel: folderPhone,
  uploadfile: fileUpload,
  upload1: upload
};

/* ECIS start */
var plugctr = new PlugCtr('kso');
/* ECIS end */

var Icon = {
  name: 'KIcon',
  props: {
    type: {
      type: String,
      required: true
    },
    formatSize: {
      type: Number,
      "default": 0
    },
    issvg: {
      // 扩展：可自定义设置不走新框架logo
      type: Boolean,
      "default": true
    },
    ecisFileName: {
      type: String
    },
    // 新视觉
    newUI: {
      type: Boolean,
      "default": false
    },
    // 是否在WPS专业版环境
    isProMode: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      imgIcons: imgIcons,
      newImgIcons: newImgIcons
    };
  },
  computed: {
    formatType: function formatType() {
      return this.type.replace(/-/g, '');
    },
    // 新框架logo支持的图片图标类型
    supportIcon: function supportIcon() {
      var _list = [].concat(_toConsumableArray(_docs), _toConsumableArray(_folder), _toConsumableArray(_s), _toConsumableArray(_l), _toConsumableArray(_xl), _toConsumableArray(_others), _toConsumableArray(_link), _toConsumableArray(_linkXl), _toConsumableArray(_linkL));
      return _list.includes(this.type);
    },
    _srcClass: function _srcClass() {
      var _size = 'sm';
      if ([].concat(_toConsumableArray(_l), _toConsumableArray(_linkL)).includes(this.type)) {
        _size = 'l';
      } else if ([].concat(_toConsumableArray(_xl), _toConsumableArray(_linkXl)).includes(this.type)) {
        _size = 'xl';
      } else if ([].concat(_toConsumableArray(_docs), _toConsumableArray(_folder), _toConsumableArray(_link)).includes(this.type)) {
        _size = 'ml';
      }
      return "k-icon k-components-icons-".concat(_size, " k-components-icons-").concat(this.type);
    },
    id: function id() {
      return "k-icon-".concat(this.type);
    },
    iconSrc: function iconSrc() {
      // 防止新图标不全，先新旧图标混用,以后再删除
      var newImgIcons = Object.assign({}, this.imgIcons, this.newImgIcons);
      var img = this.newUI ? newImgIcons : this.imgIcons;
      return img;
    }
  },
  render: function render(h) {
    /* ECIS start */
    /* @Description: 文件类型图标拓展 */
    var unknownKey = 'unknown';
    var size = 'medium';
    if ([].concat(_toConsumableArray(_l), _toConsumableArray(_linkL)).includes(this.type)) {
      unknownKey = 'unknownl';
      size = 'large';
    } else if ([].concat(_toConsumableArray(_xl), _toConsumableArray(_linkXl)).includes(this.type)) {
      unknownKey = 'unknownxl';
      size = 'x-large';
    } else if ([].concat(_toConsumableArray(_s), _toConsumableArray(_linkS)).includes(this.type)) {
      size = 'small';
    }
    var isLink = false;
    var fileType = this.type.replace(/-(l|xl|s)$/, '');
    if (fileType.indexOf('Link') > -1) {
      isLink = true;
      fileType = fileType.replace('Link', '');
    }
    var sizeMap = {
      'small': 16,
      'medium': 30,
      'large': 60,
      'x-large': 120
    };
    if ([].concat(_toConsumableArray(fileFormatIcon), _toConsumableArray(folderFormatIcon)).includes(fileType)) {
      return h(KFormatIcon, {
        props: {
          size: this.formatSize || sizeMap[size] || 30,
          fileType: fileType,
          isLink: isLink,
          isProMode: this.isProMode
        },
        "class": this._srcClass
      });
    }
    var icon = this.supportIcon && this.issvg ? h('img', {
      "class": this._srcClass,
      attrs: {
        src: this.iconSrc[this.formatType] || this.iconSrc[unknownKey]
      } // imgIcons中没有则用未知图标
    }) : h('svg', {
      "class": "k-icon ".concat(this.id),
      attrs: {
        'aria-hidden': true
      }
    }, [h('use', {
      attrs: {
        'xlink:href': "#".concat(this.id)
      }
    })]);
    return plugctr.ask('Icon.expand', {
      type: this.formatType,
      h: h,
      ecisFileName: this.ecisFileName
    }, icon);
    /* ECIS end */
  }
};

Icon.install = function (Vue) {
  Vue.component(Icon.name, Icon);
};

export { Icon as default };
